import appConfig from './appConfig';

const APP_VERSION = appConfig.version;
const LOCAL_STORAGE_VERSION_KEY = 'app_version';
const TARGET_STORAGE_KEY = 'vulnerabilityTableSettings';
const RESET_LOCAL_STORAGE_ENABLED = false;

export const resetLocalStorageOnUpdate = () => {
  if (!RESET_LOCAL_STORAGE_ENABLED) {
    return;
  }

  const storedVersion = localStorage.getItem(LOCAL_STORAGE_VERSION_KEY);

  if (!storedVersion || storedVersion !== APP_VERSION) {
    localStorage.removeItem(TARGET_STORAGE_KEY);
    localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, APP_VERSION);
  }
};
